module.exports = __webpack_public_path__ + "static/media/trotting-dark.1dfd671c.svg";